import { Suspense, useRef, useState, type FC } from 'react';
import { dibsLazy } from 'dibs-lazy/exports/dibsLazy.ts';

import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';

import { useHomePageContext } from '../HomePageContext.tsx';
import { HpSharedCarouselTabsShimmer } from '../HpSharedCarouselTabs/HpSharedCarouselTabsShimmer.tsx';

import { type HpSharedFeaturedModule_viewer$key } from './__generated__/HpSharedFeaturedModule_viewer.graphql.ts';
import { type HpSharedFeaturedModule_user$key } from './__generated__/HpSharedFeaturedModule_user.graphql.ts';

const HpSharedFeaturedModule = dibsLazy(
    'HpSharedFeaturedModule',
    () => import(/* webpackChunkName: "HpSharedFeaturedModule" */ './HpSharedFeaturedModule.tsx')
);

type Props = {
    viewer: HpSharedFeaturedModule_viewer$key | null;
    user?: HpSharedFeaturedModule_user$key | null;
    isClient: boolean;
};

export const HpSharedFeaturedModuleLazy: FC<Props> = ({ viewer, user, isClient }) => {
    const { isMobile } = useHomePageContext();
    const containerRef = useRef<HTMLDivElement>(null);
    const [hasBecomeVisible, setHasBecomeVisible] = useState(false);

    if (!isClient) {
        return null;
    }

    const shimmer = <HpSharedCarouselTabsShimmer isMobile={isMobile} />;

    return (
        <div ref={containerRef} data-tn="hp-top-deals-module">
            <VisibilityTracker
                elementRef={containerRef}
                onVisibilityChange={({ isVisible }) => {
                    if (isVisible) {
                        setHasBecomeVisible(true);
                    }
                }}
                observerOptions={{
                    rootMargin: isMobile ? '700px 0px' : '400px 0px',
                }}
            />
            {hasBecomeVisible ? (
                <Suspense fallback={shimmer}>
                    <HpSharedFeaturedModule viewer={viewer} user={user} isClient={isClient} />
                </Suspense>
            ) : (
                shimmer
            )}
        </div>
    );
};
